import {createSelector, createSlice, PayloadAction} from 'lowkey-component';

import {RootState} from '@store/rootReducer';

export interface VoiceState {
  isOpenVoiceModal: boolean;
  currentVoiceModalIndex: number;
}

const initialValues: VoiceState = {
  isOpenVoiceModal: false,
  currentVoiceModalIndex: -1,
};

export const selectVoiceState = (state: RootState) => {
  return state.voice;
};

const selectIsOpenVoiceModal = createSelector(
  selectVoiceState,
  ({isOpenVoiceModal}) => isOpenVoiceModal,
);

const selectCurrenVoiceModalIndex = createSelector(
  selectVoiceState,
  ({currentVoiceModalIndex}) => currentVoiceModalIndex,
);
const voiceSlice = createSlice({
  initialValues,
  reducers: {
    isOpenVoiceDialogSaved: (state, action: PayloadAction<boolean>) => {
      state.isOpenVoiceModal = action.payload;
    },
    currentVoiceModalIndex: (state, action: PayloadAction<number>) => {
      state.currentVoiceModalIndex = action.payload;
    },
  },
});

export const voiceSelectors = {
  selectIsOpenVoiceModal,
  selectCurrenVoiceModalIndex,
};

export const {isOpenVoiceDialogSaved, currentVoiceModalIndex} =
  voiceSlice.actions;

export const {getInitialValues} = voiceSlice;
export default voiceSlice.reducer;
